import { Link } from "react-router-dom";
import { Linkedin, Twitter } from "lucide-react";

const Footer = () => {
  return (
    <footer className="border-t border-slate-100 bg-white">
      <div className="container mx-auto px-4 py-12 flex flex-col items-center justify-center text-center">
        <Link to="/" className="flex items-center gap-2 mb-6 group">
          <span className="font-display font-bold text-xl tracking-tight text-slate-900 group-hover:text-accent transition-colors">
            <span className="text-[0.9em] opacity-80 mr-1.5">//</span>Intellr
            <span className="text-accent">.</span>
          </span>
        </Link>

        <div className="flex flex-wrap justify-center gap-8 text-sm font-medium text-slate-500 mb-8">
          <Link to="/for-employers" className="hover:text-accent transition-colors">Employers</Link>
          <Link to="/jobs" className="hover:text-accent transition-colors">Candidates</Link>
          <Link to="/pricing" className="hover:text-accent transition-colors">Pricing</Link>
          <Link to="/contact" className="hover:text-accent transition-colors">Contact</Link>
        </div>

        <div className="flex items-center gap-4 border-t border-slate-100 w-full max-w-md pt-8 justify-center">
          <p className="text-sm text-slate-400 font-bold">
            &copy; 2026 Intellr.
          </p>
          <div className="flex gap-4 text-sm text-slate-400 font-bold">
            <Link to="/terms" className="hover:text-slate-600 transition-colors">Terms</Link>
            <Link to="/privacy" className="hover:text-slate-600 transition-colors">Privacy</Link>
            <Link to="/refund-policy" className="hover:text-slate-600 transition-colors">Refund</Link>
            <Link to="/shipping-policy" className="hover:text-slate-600 transition-colors">Shipping</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
